var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chip",style:(_vm.colored ? _vm.custom_color_style(_vm.term.hex_color) : null)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.term.name))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }